import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { colors } from '../theme';
import { SvgIconProps } from './SvgIcon.types';

export const FilterControlsIcon = memo(
  ({ fontSize, color = colors.white, className }: Pick<SvgIconProps, 'fontSize' | 'color' | 'className'>) => (
    <SvgIcon
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      style={{ fontSize, color: 'rgba(255, 255, 255, 0)' }}
    >
      <path
        d="M3.3335 5.8335C4.71421 5.8335 5.8335 4.71421 5.8335 3.3335C5.8335 1.95278 4.71421 0.833496 3.3335 0.833496C1.95278 0.833496 0.833496 1.95278 0.833496 3.3335C0.833496 4.71421 1.95278 5.8335 3.3335 5.8335Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.667 19.167C18.0477 19.167 19.167 18.0477 19.167 16.667C19.167 15.2863 18.0477 14.167 16.667 14.167C15.2863 14.167 14.167 15.2863 14.167 16.667C14.167 18.0477 15.2863 19.167 16.667 19.167Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14.1668 16.667H0.833496" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.1668 3.3335H5.8335" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.1667 10H12.5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.50016 10H0.833496" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  ),
);
